demo:
  chrome:
    share: Share
